import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Wings = forwardRef<SVGSVGElement, SvgIconProps>(
  function Wings(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M18.12 11.19c-.58-.94-1.64-1-1.64-1s.83.27 1.3 1.13c1.74 3.2 3.34 3.14 3.34 3.14-3.2 1.05-4.83-2.52-5.83-2.63.37.12.71.6 1.07 1.16a4.54 4.54 0 0 0 2.48 1.82s-1.83.66-3.17-.46c-.83-.71-1.73-.78-2.08-.45-.62.6-.45 1.53-.45 1.53s-1.1-1.78-.71-3.96c.16-.9.8-1.85 1.63-2.24 1.07-.54 4.27-1.62 6.22 1.21 2.4 3.46 3.72 3.27 3.72 3.27-3.82 1.53-4.9-.95-5.88-2.52zM9.94 9.23a3.16 3.16 0 0 1 1.63 2.25c.4 2.17-.71 3.95-.71 3.95s.17-.92-.45-1.53c-.35-.33-1.25-.26-2.08.45-1.34 1.12-3.17.46-3.17.46s1.56-.38 2.48-1.82c.36-.56.7-1.04 1.07-1.15-1 .1-2.63 3.67-5.83 2.62 0 0 1.6.07 3.35-3.14.46-.86 1.29-1.12 1.29-1.12s-1.06.05-1.64.99C4.91 12.76 3.82 15.24 0 13.7c0 0 1.33.18 3.72-3.27 1.95-2.83 5.15-1.75 6.22-1.2z" />
      </SvgIcon>
    )
  },
)

export default Wings
